import React, { useState } from 'react';
import { useParams } from 'react-router';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import { hasPermissionOrAdmin, isManagedBySuperuser } from 'helpers/permissions';
import { SNAPSHOT_EDIT_PERMISSIONS, SNAPSHOT_PERMISSIONS } from 'permissions/snapshots';
import { useAppSelector } from 'store/hook';

import SnapshotEditor from './editor/SnapshotEditor';
import { useSnapshotContext } from './SnapshotContext';
import SnapshotDelete from './SnapshotDelete';
import SnapshotSelector from './SnapshotSelector';
import { useCommunityInfoContext } from '../../components/CommunityInfo/CommunityInfoContext';

const Container = styled.div`
  position: relative;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 15px;
`;

const Controls = styled.div`
  display: flex;
  gap: 10px;
`;

const Link = styled.a`
  text-decoration: none;
  margin-bottom: 10px;
`;

const Image = styled.span`
  width: 22px;
  height: 18.5px;
  background-image: url('/icons/auto-graph.svg');
  margin-right: 5px;
`;

const SnapshotControls = () => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { isCompetitor } = useCommunityInfoContext();
  const { snapshot } = useSnapshotContext();

  const [open, setOpen] = useState(false);

  const { communityId, competitorId } = useParams();

  const showEditButton = hasPermissionOrAdmin(currentUser, SNAPSHOT_EDIT_PERMISSIONS);
  const showDeleteButton = snapshot && hasPermissionOrAdmin(currentUser, [SNAPSHOT_PERMISSIONS.DELETE]);
  const deleteButtonDisabled =
    Boolean(snapshot?.shared) && !(currentUser?.isSuperuser || isManagedBySuperuser(currentUser));

  return (
    <Container>
      <Controls>
        {isCompetitor && communityId && (
          <Link href={`/competitor/${competitorId}`} target="_blank">
            <Button type="primary">
              <Image />
              Open Overview
            </Button>
          </Link>
        )}
        {showEditButton && <SnapshotEditor communityId={Number(competitorId ?? communityId)} />}
      </Controls>
      <Controls>
        <SnapshotSelector open={open} setOpen={setOpen} />
        {showDeleteButton && <SnapshotDelete disabled={open || deleteButtonDisabled} />}
      </Controls>
    </Container>
  );
};

export default SnapshotControls;
